import translate, { formatNumber } from '@/services/translate';
import {
  formatter,
  isValid,
} from '@/services/dateTime/datetimeService';

function getFormattedNumber(value, precision = 0) {
  if (typeof value !== 'number') {
    return value;
  }
  return formatNumber(value, {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  });
}

function isNumber(value) {
  const number = parseFloat(value.replace(/,/g, '.'));
  return !Number.isNaN(Number(number));
}

function getFieldName(i18nLabel) {
  return translate(i18nLabel);
}

function getFieldNameWithOptions(i18nLabel, options) {
  return translate(i18nLabel, options);
}

export {
  getFormattedNumber,
  isNumber,
  getFieldName,
  getFieldNameWithOptions,
  formatter as getFormattedDate,
  isValid as isDate,
};
